'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapsRateReview = function MapsRateReview(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
  );
};
MapsRateReview = (0, _pure2.default)(MapsRateReview);
MapsRateReview.displayName = 'MapsRateReview';
MapsRateReview.muiName = 'SvgIcon';

exports.default = MapsRateReview;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/maps/rate-review.js
 ** module id = 2229
 ** module chunks = 0
 **/